import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const FillSafe = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18.8001 2H5.2001C4.5401 2 4.0001 2.56 4.0001 3.25V8.47C3.9801 14.11 6.9901 19.3 11.8101 21.95C11.9301 22.02 12.0701 22.02 12.1801 21.95C17.0001 19.3 20.0101 14.11 19.9901 8.47V3.25C19.9901 2.56 19.4501 2 18.7901 2H18.8001ZM17.0801 8.33C17.0801 8.33 17.0801 8.33 17.0801 8.34L12.1001 14.92C11.8601 15.24 11.4101 15.3 11.0801 15.07C11.0801 15.07 11.0601 15.06 11.0601 15.05L7.5001 12.28C7.1901 12.04 7.1401 11.59 7.3901 11.28C7.6401 10.98 8.0901 10.94 8.4001 11.17L11.3701 13.48L15.9101 7.48C16.1501 7.17 16.6001 7.1 16.9201 7.33C17.2501 7.56 17.3201 8 17.0901 8.32L17.0801 8.33Z"
      fill="#565B6D"
    />
  </svg>
)

export default withDefaultStyles(FillSafe)
